const config = {
  apiKey: 'AIzaSyBuSVMjuHdVk6UXv4GKycBgLC5j62G6tPY',
  authDomain: 'twr360-dd329.firebaseapp.com',
  databaseURL: 'https://twr360-dd329.firebaseio.com',
  projectId: 'twr360-dd329',
  storageBucket: 'twr360-dd329.appspot.com',
  messagingSenderId: '861483717559',
};

export default config;



// WEBPACK FOOTER //
// ./src/firebase/config.js